/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Modal/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import ModalFullScreenNative from 'DesignSystem/ModalFullScreenNative/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaCalendarTime from 'DesignSystem/TysiaCalendarBlocks/TysiaCalendarTime/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Modal({
  children,
  viewPath = "/DesignSystem/TysiaCalendarBlocks/TysiaCalendarTimePicker/Modal",
  dayDate,
  from,
  onClick,
  isNative
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<ModalFullScreenNative
  viewPath={`${viewPath}/ModalFullScreenNative`}
 overflow="auto"
>
{childProps => (
<div
  data-testid="Modal.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Modal.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-5ni6l': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Pick a time for:"
 paddingRight={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={dayDate}
/>
</div>
<div
  data-testid="Modal.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="tysia_calendar_time"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/TysiaCalendarTime(${item?.id ?? item?._id ?? index})`}
      >
<TysiaCalendarTime
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/TysiaCalendarTime(${item?.id ?? item?._id ?? index})`}
 onClick={onClick}
 isNative={isNative}
/>
</ListItem>
)}
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 size="small"
 type="primary"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
</div>
)}
</ModalFullScreenNative>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }